<div fxLayout="column" fxLayoutAlign="start" fxLayoutGap="15px">
	<div fxLayout="row" fxLayoutAlign=" center">
		<div *ngIf="parcels?.length === 0">
			{{'parcelsView.noParcelsText' | translate}}
		</div>
		<div fxFlex fxLayoutAlign="end">
			<button (click)="handelAddParcel()" *ngIf="showAddAndEditButtons" [disabled]="!areParcelsEditable"
					[matTooltip]="!areParcelsEditable ? 'Parcels can no longer be adjusted on this shipment. Please reach out to customer service to make any changes.' : ''"
					[color]="'primary'" mat-raised-button type="button">
				{{('parcelsView.addParcelLabel' | translate)}}
			</button>
		</div>
	</div>
	<div *ngIf="parcels?.length > 0" fxLayout="column" fxLayoutAlign="start" fxLayoutGap="15px">
		<div class="mat-table-wrapper">
			<div fxLayout="row wrap" fxLayoutAlign="start" fxLayoutGap="15px">
				<mat-radio-group (change)="filterParcels($event?.value)" [value]="parcelFilter" color="primary" fxLayoutGap="15px" fxLayoutAlign="start center">
					<mat-radio-button value="showAll">{{'parcelsView.showAllLabel' | translate}}</mat-radio-button>
					<mat-radio-button value="scanned">{{'parcelsView.scannedLabel' | translate}}</mat-radio-button>
					<mat-radio-button value="over">{{'parcelsView.overLabel' | translate}}</mat-radio-button>
					<mat-radio-button value="short">{{'parcelsView.shortLabel' | translate}}</mat-radio-button>
				</mat-radio-group>
				<mat-paginator fxFlex [pageSize]="10" color="primary" fxLayoutAlign="end center"></mat-paginator>
			</div>
			<mat-table [dataSource]="dataSource">
				<ng-container matColumnDef="parcelId">
					<mat-header-cell *matHeaderCellDef>
						{{'parcelsView.parcelIdColumnHeader' | translate}}
					</mat-header-cell>
					<mat-cell *matCellDef="let element"
							  [attr.data-label]="'parcelsView.parcelIdColumnHeader' | translate">
						{{element?.id}}
					</mat-cell>
				</ng-container>
				<ng-container matColumnDef="barcode">
					<mat-header-cell *matHeaderCellDef>
						{{'parcelsView.barcodeColumnHeader' | translate}}
					</mat-header-cell>
					<mat-cell *matCellDef="let element"
							  [attr.data-label]="'parcelsView.barcodeColumnHeader' | translate">
						{{element?.reference ? element?.reference : element?.barcode}}
					</mat-cell>
				</ng-container>
				<ng-container matColumnDef="masterBarcode">
					<mat-header-cell *matHeaderCellDef>
						{{'parcelsView.masterBarcodeColumnHeader' | translate}}
					</mat-header-cell>
					<mat-cell *matCellDef="let element"
							  [attr.data-label]="'parcelsView.masterBarcodeColumnHeader' | translate">
						{{element?.customerMasterParcelId}}
					</mat-cell>
				</ng-container>
				<ng-container matColumnDef="pieces">
					<mat-header-cell *matHeaderCellDef>
						{{'parcelsView.piecesColumnHeader' | translate}}
					</mat-header-cell>
					<mat-cell *matCellDef="let element"
							  [attr.data-label]="'parcelsView.piecesColumnHeader' | translate">
						{{element?.pieces}}
					</mat-cell>
				</ng-container>
				<ng-container matColumnDef="weight">
					<mat-header-cell *matHeaderCellDef>
						{{'parcelsView.weightColumnHeader' | translate}}
					</mat-header-cell>
					<mat-cell *matCellDef="let element"
							  [attr.data-label]="'parcelsView.weightColumnHeader' | translate">
						{{element?.weight}}
					</mat-cell>
				</ng-container>
				<ng-container matColumnDef="parcelType">
					<mat-header-cell *matHeaderCellDef>
						{{'parcelsView.parcelTypeColumnHeader' | translate}}
					</mat-header-cell>
					<mat-cell *matCellDef="let element"
							  [attr.data-label]="'parcelsView.parcelTypeColumnHeader' | translate">
						{{element?.typeDescription || element?.type?.description}}
					</mat-cell>
				</ng-container>
				<ng-container matColumnDef="refrigerationType">
					<mat-header-cell *matHeaderCellDef>
						{{'parcelsView.refrigerationTypeColumnHeader' | translate}}
					</mat-header-cell>
					<mat-cell *matCellDef="let element"
							  [attr.data-label]="'parcelsView.refrigerationTypeColumnHeader' | translate">
						{{element?.refrigeration}}
					</mat-cell>
				</ng-container>
				<ng-container matColumnDef="action">
					<mat-header-cell *matHeaderCellDef [disabled]="true">
						Action
					</mat-header-cell>
					<mat-cell *matCellDef="let element; let i = index" [attr.data-label]="'parcelsView.actionLabel' | translate">
						<button [disabled]="!showAddAndEditButtons" [matTooltip]="!showAddAndEditButtons ? 'No options available' : ''"
								(click)="stopPropagation($event)" [color]="'primary'" [id]="i === 0 ? 'ACTION_MENU' : null"
								[matMenuTriggerFor]="actionMenu" mat-icon-button>
							<mat-icon>list</mat-icon>
						</button>
						<mat-menu #actionMenu="matMenu">
							<button (click)="handelEditParcel(element)" mat-menu-item
									*ngIf="showAddAndEditButtons" [disabled]="!areParcelsEditable"
									[matTooltip]="!areParcelsEditable ? 'Parcels can no longer be adjusted on this shipment. Please reach out to customer service to make any changes.' : ''">
							{{'parcelsView.editParcelLabel' | translate}}
						</button>
						<button (click)="handelPrintParcel(element?.id)" mat-menu-item>
							{{'parcelsView.printParcelDetailsLabel' | translate}}
						</button>
						<button (click)="handelEmailParcel(element?.id)" mat-menu-item>
							{{'parcelsView.emailParcelDetailsLabel' | translate}}
						</button>
						</mat-menu>
					</mat-cell>
				</ng-container>
				<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
				<mat-row *matRowDef="let row; columns: displayedColumns;" [cdkDetailRowTpl]="tpl" [cdkDetailRow]="row"
						 matRipple>
				</mat-row>
			</mat-table>
			<ng-template #tpl let-element>
				<div [@detailExpand] class="mat-row detail-row overflow-hidden">
					<app-parcel-items [stopType]="type" [assignments]="element?.assignments"></app-parcel-items>
				</div>
			</ng-template>
		</div>
	</div>
</div>
